import React from 'react';
import { motion } from 'framer-motion';
import { Wallet, CreditCard, PiggyBank, TrendingUp, Calendar, PieChart } from 'lucide-react';
export function Features() {
  const features = [{
    icon: Wallet,
    title: 'Registro de Ingresos',
    description: 'Registra todas tus fuentes de ingreso y conoce tu capacidad real de gasto.'
  }, {
    icon: CreditCard,
    title: 'Control de Gastos',
    description: 'Clasifica tus gastos y detecta fácilmente pequeños consumos que afectan tu presupuesto.'
  }, {
    icon: PiggyBank,
    title: 'Seguimiento de Ahorros',
    description: 'Establece objetivos y visualiza cómo tus ahorros avanzan mes a mes.'
  }, {
    icon: TrendingUp,
    title: 'Gestión de Deudas',
    description: 'Organiza montos, cuotas y pagos para visualizar claramente tu progreso.'
  }, {
    icon: Calendar,
    title: 'Resúmenes Mensuales',
    description: 'Analiza cómo evolucionan tus finanzas sin realizar cálculos manualmente.'
  }, {
    icon: PieChart,
    title: 'Estado Financiero Visual',
    description: 'Visualiza tu situación financiera mediante gráficos claros y fáciles de interpretar.'
  }];
  return <section className="py-10 md:py-20 bg-white" data-id="element-43" data-mp="32t9lpnb6upvk">
      <div className="container mx-auto px-4 md:px-6" data-id="element-44" data-mp="32rghsfrymjr9">
        <div className="text-center mb-8 md:mb-16" data-id="element-45" data-mp="3gs9aqw2m56s9">
          <h2 className="font-display text-2xl md:text-4xl font-extrabold text-stone-900 tracking-tight mb-2 md:mb-4" data-id="element-46" data-mp="3gqy5ssxflszk">
            Todo lo que incluye Orden Financiero™
          </h2>
          <p className="text-sm md:text-lg text-stone-600 max-w-2xl mx-auto" data-id="element-47" data-mp="3qi2nw1ieltym">
            Tus finanzas organizadas en un solo lugar.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 md:gap-8" data-id="element-48" data-mp="3dd2fyhbbll6">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="p-3 md:p-6 rounded-2xl bg-stone-50 border border-stone-100 hover:border-[#10b981]/30 transition-colors group" data-id="element-49" data-mp="3ul8tr81ltj4k" data-mpi={index}>
              <div className="w-8 h-8 md:w-12 md:h-12 bg-white rounded-xl shadow-sm flex items-center justify-center mb-2 md:mb-4 group-hover:scale-110 transition-transform duration-300" data-id="element-50" data-mp="3azn7e7hc8jw5">
                <feature.icon className="w-4 h-4 md:w-6 md:h-6 text-[#10b981]" data-id="element-51" data-mp="3ktcev5lf98c2" />
              </div>
              <h3 className="text-sm md:text-xl font-bold text-stone-900 mb-1 md:mb-2" data-id="element-52" data-mp="3ouxz5c0acowa">
                {feature.title}
              </h3>
              <p className="text-xs md:text-base text-stone-600" data-id="element-53" data-mp="1uihjxlpii0fa">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}